import tocaroLogo from '../assets/tocaroLogoWhite.webp'; // adjust the path if this file is located differently

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-gray-800 via-gray-900 to-black text-gray-300 mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-10 grid grid-cols-1 md:grid-cols-3 gap-8">
        
        {/* Logo Only */}
        <div className="flex items-center">
        <a href="https://www.tocaroblue.com">
            <img 
            src={tocaroLogo} 
            alt="Tocaro Blue Logo"
            className="max-h-12 w-auto object-contain"
            />
        </a>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-md font-semibold text-white mb-3">Quick Links</h4>
          <ul className="space-y-2">
            <li><a href="https://devkits.tocaroblue.com" className="hover:text-blue-400 transition-colors">Dashboard</a></li>
            <li><a href="https://docs.tocaroblue.com" className="hover:text-blue-400 transition-colors">Docs</a></li>
            <li><a href="/THIRD_PARTY_NOTICES.txt" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors">Open-source notices</a></li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-md font-semibold text-white mb-3">Contact</h4>
          <ul className="space-y-2">
            <li><a href="mailto:tech@tocaroblue.com" className="hover:text-blue-400">tech@tocaroblue.com</a></li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700 py-4 text-center text-sm text-gray-500">
        © {new Date().getFullYear()} Tocaro Blue. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;